<template>
    <div>
      <Head title="Profile" />
      <v-container>
            <v-card>
                <v-card-title>Profile</v-card-title>
                <v-card-text>
                    <v-form ref="editprofile" lazy-validation class="bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login" >
                        {{auth.user}}
                    </v-form>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  
  export default {
    
    props: {
        auth: Object,
        state: String,
    },
    components: {
      Head,
    },
    layout: Layout,
  }
  </script>
  